import { ModeloEtiquetaService } from 'src/app/services/geral/modelo-etiqueta.service';
import { ModeloEtiqueta } from 'src/app/model/geral/modeloEtiqueta';
import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { GeralFormModule } from './geralform.module';

@Component({
  selector: 'app-form-modeloetiqueta',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormModeloEtiquetaComponent extends FormGenerico<ModeloEtiqueta> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: ModeloEtiquetaService) 
  {
    super(injectorObj, api);
    this.obj = new ModeloEtiqueta();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
